module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo03_thumb-b660d1939b9bc83def6204a9d8891bcd.jpg";